import React from 'react'
import { useNavigate } from 'react-router-dom'
import { subscriptionCardSmallIF } from './subscriptionCardSmallIF'

export const SubscriptionCardSmall = (props: subscriptionCardSmallIF) => {
  const navigate = useNavigate()

  const handleSubscribeClick = (path: string) => {
    navigate(path)
  }

  return (
    <div className='flex flex-col justify-betwen w-[242px] h-[174px] sm:h-[269px] shadow-equal-all-sides rounded-xl p-4 sm:p-5'>
      <div className='flex flex-col text-center sm:text-left'>
        <h2 className='text-sm sm:text-2xl font-medium tracking-wide text-[#5858DF]'>
          {props.title}
        </h2>

        <hr className='pb-3' />

        <h3 className='text-[#205497] text-xs sm:text-base font-medium tracking-wide pb-3 sm:pb-[7px]'>
          {props.subTitle}
        </h3>

        <div
          className={`flex flex-row sm:flex-col ${
            props.additionalAmount ? 'justify-between' : 'justify-center'
          } items-center sm:items-start`}
        >
          <div className='flex flex-col text-left'>
            <div className='flex items-end'>
              <span className='text-base sm:text-2xl font-medium tracking-wide'>
                {props.amount}
              </span>

              {props.vatAddition && (
                <span className='text-[10px] text-[#101828] pb-1'>+ VAT</span>
              )}
            </div>

            <span className='text-[#6E7785] text-[10px]'>
              {props.occurence}
            </span>
          </div>

          {props.additionalAmount && (
            <>
              <span className='text-[#6E7785] text-sm font-medium'>+</span>

              <div className='flex flex-col text-left'>
                <div className='flex items-end'>
                  <span className='text-[#101828] font-medium tracking-wide'>
                    {props.additionalAmount}
                  </span>

                  {props.additionalAmountVat && (
                    <span className='text-[8px] pb-[3px]'>+ VAT</span>
                  )}
                </div>

                <span className='text-[#6E7785] text-[10px]'>
                  {props.additionalOccurence}
                </span>
              </div>
            </>
          )}
        </div>
      </div>

      <div className='flex h-full justify-center sm:justify-end items-end'>
        <button
          className='w-full sm:w-auto text-center text-xs font-medium tracking-wide text-white hover:text-[#65C2D7] px-[8px] py-[4px] sm:py-[8px] bg-[#020251] rounded-md'
          onClick={() => handleSubscribeClick(props.buttonLink)}
        >
          {props.buttonLabel}
        </button>
      </div>
    </div>
  )
}
